import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import vatCodeService from '../../service/vatCode.service';
import { AreaOption, CategoryOption, SubjectOption, TypeOption } from '../../config/vatCodes';

export const VatCodeReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'code', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    vatCodeService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'code',
      headerName: 'Áfakulcs',
      type: 'string',
    },
    {
      field: 'name',
      headerName: 'Megnevezése',
      type: 'string',
    },
    {
      field: 'description',
      headerName: 'Leírás',
      type: 'string',
    },
    {
      field: 'percentage',
      headerName: 'Százalék',
      type: 'string',
    },
    {
      field: 'category',
      headerName: 'Kategória',
      type: 'singleSelect',
      valueOptions: CategoryOption,
    },
    {
      field: 'area',
      headerName: 'Terület',
      type: 'singleSelect',
      valueOptions: AreaOption,
    },
    {
      field: 'subject',
      headerName: 'Tárgy',
      type: 'singleSelect',
      valueOptions: SubjectOption,
    },
    {
      field: 'type',
      headerName: 'Áfakulcs típusa',
      type: 'singleSelect',
      valueOptions: TypeOption,
    },
    {
      field: 'navo',
      headerName: 'NAV Online áfakulcs',
      type: 'string',
    },
    {
      field: 'active',
      headerName: 'Aktív',
      type: 'boolean',
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.vatCodeList}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      getRowId={(row) => row.code}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default VatCodeReports;
